module.exports = __webpack_public_path__ + "img/BES.2ba378f6.svg";